/**
 *     \
 *     |
 * ----|
 */
export default function curveDownRightInverse(fromX, fromY, curveSize) {
  const lineDown = ` M ${fromX} ${fromY}`;

  const firstHandleX = fromX;
  const firstHandleY = fromY + (curveSize / 2);

  const secondHandleX = fromX + (curveSize / 2);
  const secondHandleY = fromY + curveSize;

  const endX = fromX + curveSize;
  const endY = fromY + curveSize;

  const curveLeft = ` C ${firstHandleX} ${firstHandleY} ${secondHandleX} ${secondHandleY} ${endX} ${endY}`;

  return ` ${lineDown} ${curveLeft}`;
}
